import { dataLayerPush } from '@libs/analytics';

export const CLICK_HELP_SECTION_EVENT = 'click_help_section';

export const formatHelpAnalyticsText = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase();

export const trackHelpSectionClick = (pageSection: string, selection: string) => {
    const formattedPageSection = formatHelpAnalyticsText(pageSection);
    const formattedSelection = formatHelpAnalyticsText(selection);

    if (!formattedPageSection || !formattedSelection) {
        return;
    }

    dataLayerPush({
        event: CLICK_HELP_SECTION_EVENT,
        page_section: formattedPageSection,
        selection: formattedSelection,
    });
};
